import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Approve/refuse/finish/delete/generate-charge de tratamento servidos pelo quarkus.
const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useTreatmentActions(patientId) {
  const [isLoading, setLoading] = useState(false);

  const approve = useCallback(
    (treatmentId) => {
      setLoading(true);
      return quarkusApi
        .post(`/patients/${patientId}/treatments/${treatmentId}/approve`, null, authHeader())
        .finally(() => setLoading(false));
    },
    [patientId],
  );

  const refuse = useCallback(
    (treatmentId, refusalReason) => {
      setLoading(true);
      return quarkusApi
        .post(
          `/patients/${patientId}/treatments/${treatmentId}/refuse`,
          { refusalReason },
          authHeader(),
        )
        .finally(() => setLoading(false));
    },
    [patientId],
  );

  const finish = useCallback(
    (treatmentId, finishDate) => {
      setLoading(true);
      return quarkusApi
        .post(
          `/patients/${patientId}/treatments/${treatmentId}/finish`,
          { finishDate },
          authHeader(),
        )
        .finally(() => setLoading(false));
    },
    [patientId],
  );

  const remove = useCallback(
    (treatmentId) => {
      setLoading(true);
      return quarkusApi
        .delete(`/patients/${patientId}/treatments/${treatmentId}`, authHeader())
        .finally(() => setLoading(false));
    },
    [patientId],
  );

  const generateCharge = useCallback(
    (treatmentId) => {
      setLoading(true);
      return quarkusApi
        .get(`/patients/${patientId}/treatments/${treatmentId}/generate-charge`, authHeader())
        .finally(() => setLoading(false));
    },
    [patientId],
  );

  return { approve, refuse, finish, remove, generateCharge, isLoading };
}
